import { render, staticRenderFns } from "./teamChatLeftSidebarChats.vue?vue&type=template&id=7bd3e22d&"
import script from "./teamChatLeftSidebarChats.vue?vue&type=script&lang=js&"
export * from "./teamChatLeftSidebarChats.vue?vue&type=script&lang=js&"
import style0 from "./teamChatLeftSidebarChats.vue?vue&type=style&index=0&id=7bd3e22d&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports